var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-home"},[_c('nav-bar',{staticClass:"v-nav-mobile"}),_c('div',{staticClass:"hide-on-med-and-down box-drawer"},[_c('drawer-navigation')],1),_c('div',{staticClass:"box-content"},[_c('div',{staticClass:"container"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }